import React, { useEffect, useState } from 'react';

import Chart from 'react-apexcharts';

import { decimalUpTo } from 'Helpers/currencyFormat';

let colorPalette = ['#4472c4', '#eb7d30', '#a5a5a6'];

const formatNumbers = (val) => {
    return decimalUpTo(val.toFixed(0));
};

const defaultOptions = () => {
    return {
        chart: {
            fontFamily: 'var(--font-sans)',
            height: 400,
            type: 'line',
            width: '100%',
        },
        stroke: {
            show: true,
            width: [2, 2, 2],
            curve: 'smooth',
            colors: ['transparent', 'transparent', 'red'],
        },
        fill: {
            opacity: 1,
        },
        title: {
            text: 'Cash flow',
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded',
            },
        },
        yaxis: {
            labels: {
                formatter: formatNumbers,
            },
        },

        tooltip: {
            y: {
                formatter: formatNumbers,
            },
        },
        colors: colorPalette,
        labels: [],
        toolbar: {
            tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
            },
        },
    };
};

const defaultSeries = () => {
    return [
        {
            name: 'Revenue',
            type: 'column',
            data: [],
        },
        {
            name: 'Expenditure',
            type: 'column',
            data: [],
        },
        {
            name: 'Cum Net',
            type: 'line',
            data: [],
        },
    ];
};

export default function CashflowChart(props) {
    const [series, setSeries] = useState(defaultSeries());
    const [options, setOptions] = useState(defaultOptions());
    const [type, setType] = useState('line');
    const [height, setHeight] = useState(250);
    const styles = `
    .apexcharts-toolbar {
      display: none;
    }
    `;

    useEffect(() => {
        const data = props.data;
        const seriesData = defaultSeries();
        const optionsData = defaultOptions();

        Object.keys(data).forEach((year) => {
            optionsData.labels.push(year);
            seriesData[0].data.push(data[year].revenue);
            seriesData[1].data.push(data[year].expenditure);
            seriesData[2].data.push(data[year].cum_net);
        });

        setOptions(optionsData);
        setSeries(seriesData);
    }, []);

    return (
        <>
            <Chart options={options} series={series} type={type} height={height} />
            <style nonce={window.nonceKey}>{styles}</style>
        </>
    );
}
